import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import user from '../assets/user.png'
import styled from 'styled-components';
import { Toaster } from 'react-hot-toast';
import { useFormik } from 'formik';
import { usernameValidate } from '../Helpers/validate';
import { useAuthStore } from '../store/store'
import { Button } from '../styles/Button';
   
const Username = () => {
   const navigate = useNavigate();
   const location = useLocation();
   const setUsername = useAuthStore(state => state.setUsername);
  
  const formik = useFormik({
    initialValues: {
      username: ''
    },
    validate: usernameValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async values => {
      // console.log(values)
      setUsername(values.username);
      // navigate('/password')
       navigate('/password', { state: { from: location.state?.from } });
    }
  })

  return (
    <Wrapper>
      <Toaster position='top-center' reverseOrder={false}></Toaster>
      <div className='user-container'>
        <div className="header-container">
          <h4 className="greeting">Hello User</h4>
          <span className="userspan">Explore more by connecting with us!</span>
        </div>
        <hr />
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <img className='user-img' src={user} alt='user-img' />
          <div className="form-container">
            <input {...formik.getFieldProps('username')} 
            type='text' className='username' 
            placeholder='Username' />
            <Button type='submit'>Get Started</Button>
          </div>
        </form>
        <div>
          <hr />
          <p className='user-para'>Not a Member? 
            <span className='linkspan'><Link to='/register'>
            Register Now</Link>
            </span>
          </p>
        </div>

      </div>
    </Wrapper>
  )
}
const Wrapper = styled.section`
display:flex;
align-items:center;
justify-content:center;
margin:3rem;

.user-container{
    width: 25%;
    padding: 3rem;
    background-color:${({ theme }) => theme.colors.bg};
    box-shadow: 2px 2px 2px 4px #dfdfdf;
    display: flex;
    flex-direction: column;
    align-items: center;   
    border-radius: 8px;
  }

.header-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1rem;
  }

  .greeting {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin: 0.5rem 0;
  }

  .userspan {
    font-size: 15px;
    text-align: center;
    padding: 0.5rem;
    color: blue;
  }


form{
  display:flex;
  flex-direction:column;
  align-items:center;
  width: 100%;
}

.user-img{
  margin-top:0.5rem;
  padding:0.4rem;
  width:9rem;
  height:9rem;
  border:1px solid white;
  box-shadow:1px 1px 1px 1px #dfdfdf;
  border-radius:50%;
  object-fit: cover;
}



.form-container{
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  width: 100%;
}

hr{
  margin: 1.2rem 0;
  border: 1px solid black;
  width: 100%;
}

.user-para{
  text-align: center;
  font-size: 1.5rem;
  margin-top: 1rem;
}
 .linkspan{
    color: ${({ theme }) => theme.colors.heading};
    font-weight: bold;
    margin-left: 0.25rem;
 }

 @media (max-width: ${({ theme }) => theme.media.mobile}) {
 margin: 2rem;

.user-container {    
    padding: 1rem;
    width : 100%
  }
}

`;

export default Username
